import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

import { Card, Container, FormControl, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Toolbar, Typography, Paper, TableContainer, CardContent } from '@mui/material';
import ReactApexChart from "react-apexcharts";
import { BaseURL } from '../../common/URLs';
import React, { useEffect, useState } from 'react';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { loaderService } from '../../common/custom-loader/loader-service';
import { HELPDESK_ROLES } from '../../common/constants';
import apiClient from '../../axios';

function DashboardHomePage(props) {
  const auth = 'Bearer ' + getLocalStorageItem('id_token');
  const reqByOptions = ['Support_Executive', 'Priority(P1/P2/P3/P4)', 'Category']
  const reqByPeriodOptions = ['Last Week', 'This Week', 'Last Month', 'This Month']
  const violatedByOptions = ['Technician', 'Category', 'Priority']

  const [reqBy, setRequestBy] = useState(reqByOptions[0]);
  const [reqByPeriod, setRequestByPeriod] = useState(reqByPeriodOptions[0]);
  const [violatedBy, setViolatedByPeriod] = useState(violatedByOptions[0]);
  const [requestByTable, setRequestByTable] = useState([]);
  const [ticketdetails, setTicketdetails] = useState();
  const [ticketdetailscat, setTicketdetailscat] = useState();


  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      // backgroundColor: theme.palette.common.black,
      backgroundColor: '#8A8A8A',
      color: theme.palette.common.white,
      height: '50px',
      fontSize: 16
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  useEffect(() => {
    getticket();
    requestsTechnician();


  }, [])

  const catagory = () => {
    // setLoading(true)
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchTickectStatusCount",
      {
        "extFlag": localStorage.getItem('role') === HELPDESK_ROLES?.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive ? 1 : 0
      },
      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      // setLoading(false)
      // response.data['supportTeamPojo'] = response.data['catWiseTicketStatusPojo'];
      setRequestByTable(response.data);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const requestsTechnician = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchTickectStsWRTSupportTeam",
      {
        "extFlag": localStorage.getItem('role') === HELPDESK_ROLES?.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive ? 1 : 0
      },

      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      // setLoading(false);
      setRequestByTable(response.data);
      loaderService.hideLoader();

    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const requestsPriority = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchPriorityTicketStatus",
      {
        "extFlag": localStorage.getItem('role') === HELPDESK_ROLES?.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive ? 1 : 0
      },
      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      setRequestByTable(response.data);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const getticket = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchOpenTickectsCatWise",
      {
        "extFlag": localStorage.getItem('role') === HELPDESK_ROLES?.ExternalAdminUser || localStorage.getItem('role') === HELPDESK_ROLES?.ExternalSupportExecutive ? 1 : 0
      },

      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      let temparr1 = []
      let temparr2 = []
      response.data.map((item => {
        temparr1.push(item.categoryName)
        temparr2.push(item.ticketStatusTypePojo.totalOpenTicket)
      }))

      setTicketdetails(temparr2);
      setTicketdetailscat(temparr1);
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const reqByTechnician = {

    options: {
      title: {
        text: 'Open Requests by Category',
        align: 'center'
      },
      legend: {
        show: true,
        showForSingleSeries: false,
        onItemClick: {
          toggleDataSeries: true
        },
      },//fontSize: String(13)
      labels: ticketdetailscat,
      chart: {
        // id: "basic-bar",
        type: 'bar',
      },
      xaxis: {
        type: 'category',
        title: {
          //text: 'Category',
        },
      },
      yaxis: {
        title: {
          text: 'Open Requests',
        },
      },
      plotOptions: {
        // Bar
        bar: {
          distributed: true,
          horizontal: false,
          borderRadius: 4,
        },
      }
    },
    series: [{ name: "Open", data: ticketdetails }]
  };

  const handleReqByChange = (event) => {

    if (event == 'Support_Executive') {
      requestsTechnician();
    }
    if (event == 'Category') {
      catagory();
    }
    if (event == 'Priority(P1/P2/P3/P4)') {
      requestsPriority();
    }
    setRequestBy(event);
  };

  return (
    <>
      <Helmet>
        <title> Home | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
          Helpdesk Dashboard
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardContent>
                <Toolbar>
                  <FormControl size="small">
                    <InputLabel id="select-requestsBy">Requests by</InputLabel>
                    <Select
                      labelId="select-requestsBy"
                      id="select-requestsBy"
                      value={reqBy}
                      label="Requests by"
                      onChange={(e) => handleReqByChange(e.target.value)}
                    >
                      {reqByOptions.map((item, idx) => <MenuItem key={idx} value={item}>{item}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Toolbar>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                  <TableContainer sx={{ minWidth: 100, maxHeight: 250 }}>
                    <Table size="small" stickyHeader aria-label="customized table" sx={{ minHeight: 50 }} >
                      <TableHead>
                        <TableRow>

                          <StyledTableCell align="center"></StyledTableCell>
                          <StyledTableCell align="center">Open</StyledTableCell>
                          <StyledTableCell align="center">Awaiting End User</StyledTableCell>
                          <StyledTableCell align="center">Overdue</StyledTableCell>

                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {requestByTable?.supportTeamPojo?.map((item, idx) =>

                          <TableRow key={item.name || item.categoryName}>
                            <TableCell align="left">{item.name || item.categoryName}</TableCell>
                            <TableCell align="center">{item.ticketStatusTypePojo.openTicket}</TableCell>
                            <TableCell align="center">{item.ticketStatusTypePojo.endUserTicket}</TableCell>
                            <TableCell align="center">{item.ticketStatusTypePojo.overDueTicket}</TableCell>
                          </TableRow>

                        )}
                      </TableBody>
                      <TableFooter>
                        < TableRow>
                          <TableCell align="center" sx={{ fontSize: '20px', fontFamily: 'inherit', backgroundColor: '#D8D7D5' }} >Total</TableCell>

                          <TableCell align="center" sx={{ fontSize: '20px', fontFamily: 'inherit', backgroundColor: '#D8D7D5' }}>{requestByTable?.openTicketTotal}</TableCell>
                          <TableCell align="center" sx={{ fontSize: '20px', fontFamily: 'inherit', backgroundColor: '#D8D7D5' }}>{requestByTable?.endUserTicketTotal}</TableCell>
                          <TableCell align="center" sx={{ fontSize: '20px', fontFamily: 'inherit', backgroundColor: '#D8D7D5' }}>{requestByTable?.overDueTicketTotal}</TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </Paper>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Card>
              <CardContent>
                <ReactApexChart
                  options={reqByTechnician?.options}
                  series={reqByTechnician?.series}
                  type="bar"
                  height={299}
                  width="98%"
                />
              </CardContent>
            </Card>
          </Grid>


        </Grid>
      </Container >
      {/* } */}
    </>
  )
}
DashboardHomePage.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};
export default DashboardHomePage